export default "__VITE_ASSET__DS7c$jgf__"